import React, { useState } from 'react';
import MessageCard from '../../../../components/card/message-card';
import NormalCard from '../../../../components/card/normal-card';
import PricingTotalCard from '../../../../components/card/pricing-total-card';
import ModernConfirmModal from '../../../../components/modal/modern-confirm-modal';
import { getRentalExtendConfirmModal } from '../../../../components/modal/modern-modal-data';
import GeneralRateRow from '../../../../components/pricing/general-rate-row';
import CheckBox from '../../../../components/UI/Input/checkbox-radio/check-box-ctrl';
import { isNullOrEmpty } from '../../../../shared/utility';
import AdditionalCharges from './additional-charge';
import NoAdditionalCharges from './no-additional-charges';

function ExtensionPricing(props) {
    const [confirmModalProps, setConfirmModalProps] = useState(null);
    const { extensionCharges, reservationInfo, errorMsg, errorChargeMsg, isConfirmed, setIsConfirmed, rentalAgreementNum } = props;

    const onConfirm = () => {
        setIsConfirmed(true);
        setConfirmModalProps(null);
    }
    const onCloseConfirm = () => {
        setIsConfirmed(false);
        setConfirmModalProps(null);
    }
    const onShowConfirmModal = (e) => {
        if (e.target.checked) {
            getRentalExtendConfirmModal(setConfirmModalProps, onConfirm, onCloseConfirm);
        } else {
            setIsConfirmed(e.target.checked);
        }
    }
    return (
        <div className='flex-column extend-pricing row-gap-1' style={{ width: "50%" }}>
            <h2>Extended Price Details</h2>
            {errorMsg ?
                <MessageCard
                    contClasses="msg-error-block"
                    title="Card Authorization Denied!"
                    message={`Your card authorization for your rental ${rentalAgreementNum} has not been approved, please contact your financial institution to resolve.`}
                    iconClass="fas fa-exclamation-triangle error-icon"
                /> : ""
            }
            {
                !isNullOrEmpty(reservationInfo?.pricing?.balanceDue) ?
                    <PricingTotalCard
                        title="Your Charges"
                        rowLabel="Total"
                        total={reservationInfo?.pricing?.balanceDue}
                    /> : ""
            }
            <NormalCard title="Estimated Additional Charges">
                {extensionCharges && !errorChargeMsg ?
                    <AdditionalCharges rentalExtension={extensionCharges?.rentalExtension} />
                    : <NoAdditionalCharges />}
                {
                    !isNullOrEmpty(reservationInfo?.pricing?.balanceDue) ?
                        <GeneralRateRow
                            key="grand-total"
                            contClasses="modern-total-bg"
                            title="Grand Total"
                            total={reservationInfo?.pricing?.balanceDue + extensionCharges?.rentalExtension?.totalAuth}
                        /> : ""
                }
                {extensionCharges && !errorChargeMsg &&
                    <MessageCard
                        contClasses="msg-warning-block"
                        message="Extension charges will be immediately charged to your card used at the pick-up time."
                        iconClass="fa fa-info-circle"
                    />}
                {extensionCharges && !errorChargeMsg &&
                    <NormalCard title="Estimated Additional Charges">
                        <CheckBox
                            name="sameAsRentFromLoaction"
                            placeholder="I’ve confirmed that I'm extending this reservation."
                            checked={isConfirmed}
                            onChange={onShowConfirmModal}
                        // disabled={disabled}
                        />
                    </NormalCard>
                }
            </NormalCard>
            {confirmModalProps &&
                <ModernConfirmModal {...confirmModalProps} />}
        </div>
    )
}

export default ExtensionPricing